// extracted by mini-css-extract-plugin
export default {"member":"PlayerTypePill_member__gnVm3","guest":"PlayerTypePill_guest__W8VY6"};